import VeeValidate from 'vee-validate';


VeeValidate.Validator.extend('video', {
  getMessage: field => 'The ' + field + ' value is not a valid video src.',
  validate: (value) => {
    return new Promise(resolve => {
      const videoTest = document.createElement("VIDEO")
      videoTest.src = value

      videoTest.oncanplay = function() {
        resolve({
          valid: true
        })
      }

      videoTest.onerror = videoTest.onabort = function() {
        resolve({
          valid: false
        })
      }
    })
  }
});

VeeValidate.Validator.extend('image', {
  getMessage: field => 'The ' + field + ' value is not a valid image src.',
  validate: (value) => {
    return new Promise(resolve => {
      const img = new Image();
      img.src = value
      
      img.onerror = img.onabort = function() {
        resolve({
          valid: false
        })
      }
      img.onload = function() {
        resolve({
          valid: true
        })
      }
    })
  }
});

export default VeeValidate